/**
 * 発電形式 9 区分の既定順・既定色・`StackOrderItem` 既定値は
 * `~/constants/generationSource`（共有 SoT。BalanceGeneration も参照する）へ
 * 昇格済み。 このファイルには Settings 画面固有の定数のみを残す
 * (2026-09-11 是正)。
 */

/**
 * UpdatePersonalSettings の FieldMask paths 定数。
 * proto の top-level フィールド名と対応 (dot-separated nested は不可)。
 */
export const FIELD_PATHS = {
  theme: 'theme',
  monitoringUnit: 'monitoring_unit',
  showTicker: 'show_ticker',
  businessAreas: 'business_areas',
  stackOrder: 'stack_order',
  orderBookColumnOrder: 'order_book_column_order',
} as const
